import React, { useContext, useState } from "react";
import { isMobile } from "react-device-detect";
import { Link, useHistory, useLocation } from "react-router-dom";

import { SettingsContext } from "../../contexts";
import { Visible } from "../../core/components";
import { ProductPreview } from "../../product/components";
import {
  TYPE_FAVOURITE_PRODUCTS,
  TYPE_FAVOURITE_LISTINGS,
} from "../../contexts/Favourites";
import { AddToCartButton, Money, Star, EnquireButton } from "../../components";
import { ListingBadges as Badges } from "./index.jsx";
import { LinkHelper } from "../../helpers";
import { getFileUrl } from "../../core/config/api.js";
import { getBaseCurrency } from "../../core/currency";
import { Button } from "../ui";

const VerticalListing = ({ user, listing, isProduct }) => {
  const { isShopify, iframeQueryParams } = useContext(SettingsContext);
  const location = useLocation();
  const history = useHistory();
  const url = LinkHelper.listingLink(listing);
  const whatsAppEnquireMessage =
    "Hi, I am interested in this listing and would like to know its price. " +
    url;

  const path =
    location.pathname.indexOf("/sell-request") === 0
      ? "sell-request"
      : "order-request";

  return (
    <div className={`${isMobile ? "px-1 mt-2" : ""} col-md-3 col-6`}>
      <div className={`${isMobile ? "border" : ""} listing vertical`}>
        <Star
          item={listing}
          type={isProduct ? TYPE_FAVOURITE_PRODUCTS : TYPE_FAVOURITE_LISTINGS}
        />

        <Badges listing={listing} />

        <Link
          to={{
            pathname: isProduct
              ? `/products/wishlist?preview=${listing.id}?${iframeQueryParams}`
              : `/product/${listing.id}?${iframeQueryParams}`,
            data: { listing },
          }}
        >
          <div className="image">
            {listing.image_id > 0 && (
              <img src={getFileUrl(listing.image_id)} />
            )}
          </div>

          <div className="brand-model-spacer mb-25">
            <h3>{listing.brand_name}</h3>
            <h4 className="suspension-points">{listing.model_name}</h4>
          </div>
        </Link>

        <span className="price">
          <Money amount={listing.price} currency={listing.currency ?? getBaseCurrency()} />
        </span>

        <Visible when={!isProduct && !isShopify}>
          <div className="actions">
            {!!listing.price && <AddToCartButton listing={listing} variant="secondary" />}
            {!listing.price && (
              <EnquireButton whatsAppEnquireMessage={whatsAppEnquireMessage} variant="secondary" />
            )}
          </div>
        </Visible>

        <Visible when={isProduct}>
          <div className="actions">
            <Button
              variant="secondary"
              onClick={() => {
                history.push(
                  `/${path}/product/${listing.id}/client?${iframeQueryParams}`
                );
              }}
              data-btn="product-select-card"
            >
              Select
            </Button>
          </div>
        </Visible>
      </div>

      {isProduct && <ProductPreview renderedForId={listing.id} />}
    </div>
  );
};

export default VerticalListing;
